import { createRouter, createWebHistory } from "vue-router";
import { useAppRefState } from "@/stores/appref";
import Tr from "@/constants/i18n/translation";

// import Dashboard from "@/pages/user/Dashboard.vue";
const appRefState = useAppRefState();
// const isAdmin = true; //sampe dummy
// const isAuth = false;
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  routes: [
    {
      path: "/",
      name: "rootdir",
      beforeEnter: Tr.routeMiddleware,
      component: () => import("@/pages/MainForm.vue"),
      meta: { layout: "main", mustAdmin: false, transition: "fade" },
    },
    {
      path: "/verify/:url",
      name: "verifyPassword",
      beforeEnter: Tr.routeMiddleware,
      component: () => import("@/pages/PasswordVerify.vue"),
      meta: { layout: "main", mustAdmin: false, transition: "fade" },
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      beforeEnter: Tr.routeMiddleware,
      component: () => import("@/pages/Error401.vue"),
      meta: { layout: "main", mustAdmin: false, transition: "fade" },
    },
    {
      /* Not found page route */
      path: "/:pathMatch(.*)*",
      name: "notfound",
      component: () => import("@/pages/Error404.vue"),
      meta: { layout: "admin", mustAdmin: false, transition: "fade" },
    },
  ],
});

router.afterEach(() => (appRefState.value.sideMenuIsOpen = false));

router.onError((error) => {
  if (error.message.includes("Failed to fetch dynamically imported module")) {
    console.log("Gagal memuat komponen");
  }
});

export default router;